export default "__VITE_ASSET__DGg7Ax5p__"